import React from 'react';
import { cn } from '../../lib/utils';
import { AppIcon } from '../icons/AppIcon';

// Root
export const Breadcrumb: React.FC<React.HTMLAttributes<HTMLElement>> = ({ className, ...props }) => (
    <nav aria-label="breadcrumb" className={cn('flex', className)} {...props} />
);

// List
export const BreadcrumbList: React.FC<React.HTMLAttributes<HTMLOListElement>> = ({ className, ...props }) => (
    <ol
        className={cn('flex flex-wrap items-center gap-1 text-sm text-foreground', className)}
        {...props}
    />
);

// Item
export const BreadcrumbItem: React.FC<React.HTMLAttributes<HTMLLIElement>> = ({ className, ...props }) => (
    <li className={cn('flex items-center gap-1', className)} {...props} />
);

// Link (clickable)
export const BreadcrumbLink: React.FC<
    React.HTMLAttributes<HTMLSpanElement> & { href?: string; onClick?: () => void }
> = ({ className, href, onClick, ...props }) => (
    <span
        role={onClick || href ? 'button' : undefined}
        onClick={onClick}
        className={cn(
            'text-sm text-foreground transition-colors',
            (onClick || href) && 'opacity-80 hover:opacity-100 cursor-pointer',
            className
        )}
        {...props}
    />
);

// Current page (non-clickable, visually distinct)
export const BreadcrumbPage: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => (
    <span
        aria-current="page"
        className={cn('text-sm font-medium text-foreground', className)}
        {...props}
    />
);

// Separator
export const BreadcrumbSeparator: React.FC<React.HTMLAttributes<HTMLLIElement>> = ({ className, ...props }) => (
    <li
        aria-hidden="true"
        className={cn('text-foreground opacity-60 flex items-center', className)}
        {...props}
    >
        <AppIcon name="chevron-right" className="w-3 h-3" />
    </li>
);
